import _ from "lodash";
import moment from "moment-timezone";
import React, { useEffect, useState } from "react";

const EventDates = ({ relatedEvents, date, endDate, showtime, end }) => {
  const elemFound = _.find(relatedEvents, (event) => {
    if (event.attributes.manual) {
      return true;
    }
  });
  if (!elemFound) {
    relatedEvents.push({
      attributes: {
        manual: true,
        date,
        showtime,
        end: endDate,
      },
    });
  }

  const sortedDays = _.orderBy(relatedEvents, ["attributes.date"], ["asc"]);

  return (
    <>
      {sortedDays.map((day) => (
          <>
            {moment(day.attributes.date)
              .tz("Europe/Zurich")
              .format("dddd, DD MMMM YYYY  |  ")
              .toUpperCase() +
              moment(day.attributes.showtime)
                .tz("Europe/Zurich")
                .format("HH:mm - ")}
            {moment(day.attributes.end).tz("Europe/Zurich").format("HH:mm")}
            <br />
          </>
        ))}
    </>
  );
};

export default EventDates;
